/**
 * Page numbers for the public news list: /news is page 1, /news/pages/N the
 * rest. Pure so the URL rules and the page-button layout are unit-tested.
 */

// Shared with the server, which renders the same first page into the HTML (Plan AE 4.1).
export { NEWS_PAGE_SIZE, parsePageParam } from '@hbac/contract';

/** The address of a list page. Page 1 is /news itself, so there is one URL per page. */
export function newsPagePath(page: number, categorySlug?: string | null): string {
  const path = page <= 1 ? '/news' : `/news/pages/${page}`;
  return categorySlug ? `${path}?category=${encodeURIComponent(categorySlug)}` : path;
}

export type PageItem = number | 'gap';

/**
 * The buttons to show: always the first and last page, the current one with
 * `siblings` on each side, and a gap where pages are skipped. A gap never
 * stands for a single page; that page is shown instead.
 */
export function pageItems(current: number, total: number, siblings = 1): PageItem[] {
  if (total <= 1) return [1];
  const c = Math.min(Math.max(current, 1), total);
  const wanted = new Set<number>([1, total]);
  for (let p = c - siblings; p <= c + siblings; p++) if (p >= 1 && p <= total) wanted.add(p);
  const sorted = [...wanted].sort((a, b) => a - b);
  const out: PageItem[] = [];
  for (const p of sorted) {
    const prev = out[out.length - 1];
    if (typeof prev === 'number' && p - prev === 2) out.push(prev + 1);
    else if (typeof prev === 'number' && p - prev > 2) out.push('gap');
    out.push(p);
  }
  return out;
}
